// Imports
import { css } from 'styled-components/macro';


// Styled component
export const visuallyHiddenLabelStyle = css`
	clip: rect(0 0 0 0);
	clip-path: inset(50%);
	height: 0.0625rem;
	overflow: hidden;
	position: absolute;
	white-space: nowrap;
	width: 0.0625rem;
`;
